module.exports = __webpack_public_path__ + "static/wws-logo-e9db142b917f8eba59d0868b48103bba.jpg";